<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <validation-observer ref="rulesPayment">
            <b-row class="mb-1">
              <b-col cols="3">
                <b-form-group
                  label="Plano"
                  label-for="group_id"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules="required|min:1"
                  >

                    <b-form-select
                      id="payment_group_id"
                      v-model="payment.group_id"
                      :options="groups"
                      :state="errors.length > 0 ? false:null"
                      :disabled="isLoading || isSubmiting || isCreatingPayment || phase > 1"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group
                  label="Período"
                  label-for="period"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules="required|min:1"
                  >
                    <b-form-select
                      id="payment_plan_id"
                      v-model="payment.plan_id"
                      :options="periods"
                      :state="errors.length > 0 ? false:null"
                      :disabled="isLoading || isSubmiting || isCreatingPayment || phase > 1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group
                  label="Destaque"
                  label-for="period"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules="required|min:1"
                  >
                    <b-form-select
                      id="payment_additionals"
                      v-model="payment.turbo"
                      :options="turbo"
                      :state="errors.length > 0 ? false:null"
                      :disabled="isLoading || isSubmiting || isCreatingPayment || phase > 1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group
                  label="Método de pagamento"
                  label-for="method"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules="required|min:1"
                  >
                    <b-form-select
                      id="payment_method"
                      v-model="payment.method"
                      :options="method"
                      :state="errors.length > 0 ? false:null"
                      :disabled="isLoading || isSubmiting || isCreatingPayment || phase > 1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group
                  label="Desconto (em %)"
                  label-for="percent"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules=""
                  >
                    <b-form-input
                      id="payment_percent"
                      v-model="percent"
                      :disabled="isLoading || isSubmiting || isCreatingPayment || phase > 1"
                      @focus="typeDiscountField = 'percent'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group
                  label="Desconto (em R$)"
                  label-for="discount"
                >
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                  >
                    <money
                      v-model="discount"
                      class="form-control"
                      v-bind="{ decimal: ',', thousands: '.', prefix: 'R$ ', precision: 2, masked: false }"
                      :disabled="isLoading || isSubmiting || isCreatingPayment || phase > 1"
                      @focus.native="typeDiscountField = 'discount'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <label>Total</label>
                <div>R$ {{ totalPrice }}</div>
              </b-col>

              <b-col
                v-if="payment.method === 'boleto'"
                cols="3"
              >
                <b-form-group
                  label="Vencimento"
                  label-for="expires_at"
                >
                  <flat-pickr
                    id="payment_expires_at"
                    ref="datePicker"
                    v-model="payment.expires_at"
                    class="form-control"
                    :disabled="isLoading || isSubmiting || isCreatingPayment || phase > 1"
                    :config="{
                      allowInput: false,
                      position: 'auto center',
                      enableTime: false,
                      dateFormat: 'Y-m-d',
                      altFormat: 'd/m/Y',
                      altInput: true,
                      locale: Portuguese,
                    }"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>

          <b-row
            v-if="phase >= 2"
            class="mt-4"
          >
            <b-col cols="12">
              <h3>Link gerado</h3>
            </b-col>
            <b-col cols="12">
              <div class="details">
                <label>Link: </label>
                <a
                  :href="payment.link"
                  target="_blank"
                >{{ payment.link }}</a>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <div
                v-if="isLoading"
                class="mr-1 d-inline-block"
              >
                <b-spinner small />
                <span class="ml-1">Carregando...</span>
              </div>

              <b-button
                v-if="phase == 1"
                align="right"
                variant="primary"
                type="submit"
                :disabled="isLoading || isCreatingPayment"
                @click.prevent="createPayment()"
              >
                <span>Criar link de pagamento</span>
                <b-spinner
                  v-if="isCreatingPayment"
                  class="ml-1"
                  small
                />
              </b-button>

              <b-button
                v-if="phase == 2"
                align="right"
                variant="primary"
                type="submit"
                @click="close()"
              >
                <span>Fechar</span>
              </b-button>
            </b-col>
          </b-row>

        </b-card>
      </b-col>

    </b-row>
  </div>
</template>

<script>
// import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ProductService from '@/services/productService'
import PlanService from '@/services/planService'
import UserService from '@/services/userService'
import { Money } from 'v-money'
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BButton,
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BButton,
    Money,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
    filterByUser: {
      type: Number,
      default: null,
    },
    filterById: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      Portuguese,
      isLoading: true,
      isSubmiting: false,
      isCreatingPayment: false,
      phase: 1,
      user: null,
      percent: '',
      discount: '',
      typeDiscountField: '',
      payment: {
        group_id: null,
        plan_id: null,
        turbo: null,
        link: '',
        email: '',
        percent: 0,
        discount: 0,
        transaction_id: null,
        expires_at: null,
      },
      method: [
        { value: 'credit_card', text: 'Cartão de Crédito' },
        { value: 'boleto', text: 'Boleto' },
        { value: 'pix', text: 'Pix' },
      ],
      plans: [],
      products: [],
      productSuper: null,
      turbo: [
        { value: 1, text: 'Sim' },
        { value: 0, text: 'Não' },
      ],
      planService: null,
      productService: null,
      userService: null,
    }
  },

  computed: {
    groups() {
      return this.plans.map(m => ({
        value: m.id,
        text: m.name,
      })).filter(f => (f.value !== 1))
    },

    planPrice() {
      const group = this.plans.find(f => f.id === this.payment.group_id)
      let plan
      if (group) {
        plan = group.plans.find(f => f.id === this.payment.plan_id)
      }

      if (plan) {
        let turbo = this.payment.turbo ? this.productSuper.price : 0
        if (plan.payment_interval === 'quarterly') {
          turbo *= 3
        } else if (plan.payment_interval === 'semiannual') {
          turbo *= 6
        } else if (plan.payment_interval === 'yearly') {
          turbo *= 12
        }
        return plan.price + turbo
      }

      return 0
    },

    totalPrice() {
      return parseFloat(this.planPrice - this.payment.discount).toFixed(2)
    },

    periods() {
      const plan = this.plans.filter(f => (
        f.id === this.payment.group_id
      ))

      if (plan.length > 0) {
        return plan[0].plans.map(m => ({
          value: m.id,
          text: m.payment_interval_label,
        }))
      }

      return []
    },
  },

  watch: {
    discount(event) {
      if (this.typeDiscountField === 'discount') {
        this.payment.discount = event
        this.percent = ''
        this.payment.percent = this.percent
      }
    },

    percent(event) {
      if (this.typeDiscountField === 'percent') {
        this.payment.percent = event
        this.discount = parseFloat(parseFloat(this.planPrice * (event / 100)).toFixed(2))
        this.payment.discount = this.discount
      }
    },
  },

  async created() {
    this.planService = new PlanService()
    this.userService = new UserService()
    this.productService = new ProductService()

    this.payment.expires_at = (new Date((new Date()).setDate((new Date()).getDate() + 3)).toISOString().substr(0, 10))

    this.isLoading = true
    await this.getPlans()
    await this.getUser()
    await this.getProducts()

    this.payment.email = this.user.email
    this.isLoading = false
  },

  methods: {
    close() {
      this.$emit('close')
    },

    getUser() {
      return this.userService.get(this.userId).then(response => {
        this.user = response.data.data.user
      })
    },

    getProducts() {
      this.productService.list().then(response => {
        this.products = response.data.data.products
        this.productSuper = this.products.find(f => f.type === 'weight_in_search_ordering')
      })
    },

    getPlans() {
      return this.planService.list().then(response => {
        this.plans = response.data.data.plans
      })
    },

    sendEmail() {
      this.isSubmiting = true
      this.userService.sendChagerFromTransaction(this.payment.transaction_id, this.payment.email).then(response => {
        this.isSubmiting = false
        if (response.data.success) {
          this.$emit('email-sent')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'E-mail Enviado',
              text: 'E-mail com cobrança enviado com sucesso!',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        } else {
          this.isSubmiting = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erros de validação',
              text: response.data.message,
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        }
      }).catch(() => {
        this.isSubmiting = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erros de validação',
            text: 'Algum erro ocorreu',
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      })
    },

    createPayment() {
      return this.$refs.rulesPayment.validate().then(success => {
        if (success) {
          this.isCreatingPayment = true
          this.userService.createPayment(
            this.userId,
            this.payment.plan_id,
            this.payment.method,
            this.payment.discount,
            this.payment.turbo,
            this.payment.expires_at,
          ).then(response => {
            if (response.data.success) {
              this.payment.link = response.data.url
              this.payment.transaction_id = response.data.transaction_id
              this.phase = 2
              this.$emit('payment-created', {})
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Erros de validação',
                  text: response.data.message,
                  icon: 'BellIcon',
                  variant: 'danger',
                },
              })
            }

            this.isCreatingPayment = false
          }).catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erros de validação',
                text: error.response.data.message,
                icon: 'BellIcon',
                variant: 'danger',
              },
            })
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erros de validação',
              text: 'Preencha todos os campos obrigatórios',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        }
      })
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .header-card{
    margin-bottom: 20px;
  }

  .label-date{
    display: block;
    margin-top: 30px;
    font-weight: bold;
  }

  .form-buttons button{
    margin-right: 10px;
  }

  .details{
    label{
      margin-right: 10px;
    }

    label, span{
      font-size: 14px;
    }
  }
</style>
